// extracted by mini-css-extract-plugin
export default {"container":"adminHome_container__KFKVh"};